import type { MoneyMap, MoneyMapUpsertDto } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useUpsertMoneyMap = requestBuilder.mutation<
    MoneyMap,
    MoneyMapUpsertDto
>({
    endpoint: () => `/api/admin/money-map`,
    method: 'POST',
});
